/* main react */
import React from 'react';

/* image */
import Loading from '../../assets/loading-yellow.gif'

const Spinner = () => (
  <div className='loading-container'>
    <img src={Loading} width={200} height={100}/>
  </div>
);

export default Spinner;
